module.exports = __webpack_public_path__ + "static/media/thumbnail.3b290c3d.jpg";